var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgControlTower01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 89 89",
    style: {
      enableBackground: "new 0 0 89 89"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#060606;}\n\t.st2{fill:#040404;}\n\t.st3{fill:#020202;}\n\t.st4{fill:#5A5A5A;}\n\t.st5{fill:#FCBC00;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M35.2,75.5c0-0.2-0.1-0.3-0.1-0.5c0-5.3,0-10.6,0-15.9c0-0.2,0-0.4,0-0.6c6.2,0,12.3,0,18.5,0 c0,0.2,0.1,0.4,0.1,0.5c0,5.4,0,10.8,0,16.1c0,0.1,0,0.2-0.1,0.4C47.5,75.5,41.4,75.5,35.2,75.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M53.7,51.9c0,1.5,0,2.9,0,4.5c-6.2,0-12.3,0-18.5,0c0-1.5,0-2.9,0-4.5C41.3,51.9,47.5,51.9,53.7,51.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M56.8,25.3c-0.2,0-0.3-0.1-0.5-0.1C56.5,25.2,56.6,25.2,56.8,25.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M28.5,41.4C28.5,41.4,28.5,41.4,28.5,41.4c0,0.1-0.1,0.1-0.1,0.1C28.5,41.4,28.5,41.4,28.5,41.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M33.8,15.5c0,0,0.1,0.1,0.1,0.1C33.9,15.5,33.8,15.5,33.8,15.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M32.6,25.1c0,0-0.1,0.1-0.1,0.1C32.5,25.1,32.5,25.1,32.6,25.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M42.1,34.8c-0.4-0.1-0.5-0.3-0.2-0.6C42,34.4,42,34.6,42.1,34.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3,39c0.1-0.1,0.2-0.2,0.3-0.2c0.1,0.1,0.2,0.1,0.2,0.2C56.7,39,56.5,39,56.3,39z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47,38.9c0.2,0.1,0.3,0.2,0.5,0.4C47.3,39.1,47.1,39,47,38.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M62.9,30.3c-1.6,0-3.3,0-4.9,0c-0.2,0-0.4,0-0.6,0c0-1.2,0.1-2.4,0-3.6c0-0.5-0.4-0.9-0.5-1.4 c-0.2,0-0.3-0.1-0.5-0.1c-3,0-6,0-9,0c0-2.9,0-5.7,0-8.5c1.7,0,3.4,0,5.1,0c1.8,0,3.7-1.5,3.2-3.1c-7.5,0-15,0-22.7,0 c0.3,0.7,0.5,1.3,0.8,2c0,0,0.1,0.1,0.1,0.1c0.6,0.7,1.5,1.1,2.7,1.1c1.7,0,3.5,0,5.2,0c0,2.8,0,5.6,0,8.4c-3.1,0-6.2,0-9.2,0 c0,0-0.1,0.1-0.1,0.1c-0.6,0.4-0.7,0.8-0.7,1.4c0.1,1.3,0,2.5,0,3.8c-1.9,0-3.7,0-5.4,0c-1.5,0-2.1,0.6-1.6,1.8 c1.3,3.1,2.6,6.2,3.9,9.3c0,0,0,0.1,0,0.1c0.1,0,0.2,0.1,0.2,0.1c0.7,0.8,1.6,1.2,2.9,1.2c1.2,0,2.3,0,3.5,0c0,2.4-1.2,4.6-1.2,6.9 c6.2,0,14.8,0,21,0c0-2.3-1.2-4.6-1.2-6.9c1.3,0,2.5,0,3.8,0c0.5,0,1-0.1,1.3-0.2c1-0.4,1.6-1.2,1.9-2.1c1.2-2.9,2.4-5.7,3.6-8.5 C64.8,31,64.2,30.3,62.9,30.3z M36.5,38.8c0,0.3-0.1,0.5-0.6,0.5c-1.4,0-2.7,0-4.1,0c-0.4,0-0.6-0.1-0.6-0.5c0-1.7,0-3.5,0-5.2 c0-0.4,0.2-0.5,0.6-0.5c1.3,0,2.7,0,4,0c0.5,0,0.6,0.2,0.6,0.5c0,0.9,0,1.7,0,2.6C36.4,37.1,36.4,37.9,36.5,38.8z M49.1,39.3 c-1.5,0-3.1,0-4.6,0c-1.5,0-3,0-4.6,0c-0.5,0-0.7-0.1-0.6-0.5c0-1.7,0-3.4,0-5.1c0-0.4,0.1-0.6,0.7-0.6c3.1,0,6.1,0,9.2,0 c0.5,0,0.7,0.1,0.6,0.5c0,1.7,0,3.4,0,5.1C49.8,39.2,49.5,39.3,49.1,39.3z M57.2,39.3c-1.4,0-2.7,0-4.1,0c-0.5,0-0.6-0.2-0.6-0.5 c0-0.9,0-1.7,0-2.6c0-0.9,0-1.7,0-2.6c0-0.3,0.2-0.5,0.6-0.5c1.4,0,2.7,0,4.1,0c0.4,0,0.6,0.1,0.6,0.4c0,1.8,0,3.5,0,5.3 C57.8,39.2,57.6,39.3,57.2,39.3z"
  }))), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 297.6382 420.9452)",
    style: {
      fontFamily: "'MyriadPro-Regular'",
      fontSize: 12
    }
  }, "FCBC00"));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgControlTower01);
export default __webpack_public_path__ + "static/media/control-tower-01.124afa625d37665dcbe3c0581d1cdb68.svg";
export { ForwardRef as ReactComponent };